






































import {
  TranslateResult,
} from 'vue-i18n';
import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';

import {
  i18n,
} from '@/plugins/vue-i18n';

import ProfileAvatar from './ProfileAvatar.vue';


interface MenuAction {
  label: string | TranslateResult;
  routeName: string;
  icon: string;
}

@Component({
  name: 'header-profile',
  components: {
    ProfileAvatar,
  },
})
export default class HeaderProfile extends Vue {
  @Prop(Boolean)
  isAuthenticated!: boolean;

  @Prop(String)
  name!: string;

  @Prop(String)
  email!: string;

  @Prop({ type: Boolean, default: true })
  showMenu!: boolean;

  private readonly menuActions: MenuAction[] = [
    {
      label: i18n.t('components.headerProfile.profile'),
      routeName: 'profile',
      icon: 'man-user',
    },
    {
      label: i18n.t('components.headerProfile.logout'),
      routeName: 'logout',
      icon: 'logout',
    },
  ];

  private isMenuVisible: boolean = false;

  private toggleMenu(): void {
    this.isMenuVisible = !this.isMenuVisible;
  }

  private onLabelClick(): void {
    if (this.isAuthenticated) {
      this.toggleMenu();
    }
  }

  private onDocumentClick(event: MouseEvent): void {
    const { target } = event;

    if (!this.isMenuVisible) {
      return;
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (target && !this.$el.contains(target as Node)) {
      this.toggleMenu();
    }
  }

  private mounted(): void {
    document.addEventListener('click', this.onDocumentClick);
  }

  private beforeDestroy(): void {
    document.removeEventListener('click', this.onDocumentClick);
  }
}
